<script setup lang="ts">
import { computed } from 'vue';
import InputPanel from './components/InputPanel.vue';
import ResultsSummary from './components/ResultsSummary.vue';
import ChartsPanel from './components/ChartsPanel.vue';
import YearTable from './components/YearTable.vue';
import ReportMode from './components/ReportMode.vue';
import TaxPathsChart from './components/TaxPathsChart.vue';
import { simulateComparison } from './lib/simulate';
import { useScenarioStore } from './store/scenario';

const store = useScenarioStore();
const result = computed(() => simulateComparison(store.scenario));
const scenario = computed(() => store.scenario);
</script>

<template>
  <div class="page">
    <InputPanel />
    <div class="stack">
      <header class="card">
        <h2>Poland JDG vs. Overengineered Plan</h2>
        <p class="muted">
          Planning tool comparing JDG on ryczałt against a sp. z o.o. long-term vehicle. All rates are editable; no tax
          tables are baked in. Calculations are simplified and deterministic. Use as a sandbox, not advice.
        </p>
        <div class="badge">Fully static · stores inputs locally · share via URL hash</div>
      </header>
      <ResultsSummary :result="result" />
      <div class="card">
        <h3>Computation breakdown</h3>
        <ul class="muted">
          <li>Simulated monthly for the selected horizon; monthly return derived from annual assumption.</li>
          <li>JDG: revenue → ryczałt → ZUS/health drag → bookkeeping → life-need → invest remainder; cap gains taxed per rebalancing rule.</li>
          <li>Sp. z o.o.: revenue → operating/admin → salary (solver optional) → CIT/estonian logic → optional dividends or loan → invest retained cash; portfolio taxes follow company settings.</li>
          <li>Owner cash is a single bucket (salary + dividends + loans, net of debt service); monthly life-need gaps are flagged from that bucket.</li>
          <li>Wealth excludes consumption; consumption is surfaced separately for context.</li>
          <li>Retirement mode enforces full exit at horizon (liquidate, tax, distribute 100% to owner); “keep in company” is only honored in manual mode. Estonian simple/detailed modes are mutually exclusive.</li>
        </ul>
      </div>
      <ChartsPanel :result="result" />
      <TaxPathsChart :result="result" />
      <YearTable :result="result" />
      <ReportMode :scenario="scenario" :result="result" />
    </div>
  </div>
</template>

<style scoped>
.stack {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
</style>
